function initCollectionDiferenciaisAccordions(root = document) {
  root.querySelectorAll('.collection-diferenciais__accordion[data-accordion-mode="single"]').forEach((container) => {
    if (container.dataset.accordionSingleInit === 'true') return;
    container.dataset.accordionSingleInit = 'true';

    const accordions = [...container.querySelectorAll('details-accordion')];

    accordions.forEach((accordion) => {
      if (!accordion.summary) return;

      accordion.summary.addEventListener('click', () => {
        requestAnimationFrame(() => {
          if (accordion.isClosing) return;

          accordions.forEach((other) => {
            if (other !== accordion && other.el?.open) {
              other.shrink();
            }
          });
        });
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initCollectionDiferenciaisAccordions();
});

document.addEventListener('shopify:section:load', (event) => {
  initCollectionDiferenciaisAccordions(event.target);
});
